import styled from 'styled-components';

const ActionButton = styled.button`
  padding: 0.75rem;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  margin-bottom: 1.5rem;
  margin-right: 1.5rem;

  &:hover {
    opacity: 0.9;
  }
`;

export default ActionButton;